import { Controller } from "@hotwired/stimulus"
import { FormBusyRegistry } from "../lib/form_busy_registry.mjs"

// The visible submit copy/disabled state is Turbo's built-in contract. This controller only
// closes the cache edge case where a page leaves while a request is still in flight.
export default class extends Controller {
  connect() {
    this.registry = new FormBusyRegistry()
  }

  start(event) {
    this.registry.start(event.target, event.detail.formSubmission)
  }

  finish(event) {
    this.registry.finish(event.target)
  }

  nativeSubmit(event) {
    if (event.defaultPrevented) return

    this.registry.startNative(event.target, event.submitter)
  }

  reset() {
    this.registry.reset()
  }
}
